import { render, staticRenderFns } from "./StoreBtn.vue?vue&type=template&id=7b69cbee&"
import script from "./StoreBtn.vue?vue&type=script&lang=ts&"
export * from "./StoreBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/app/components/base/Button.vue').default})
